import './_process_shim';
import ReactRailsUJS from 'react_ujs';
import { buildContext } from './_react_ujs_context';
import '../public/styles/main.scss';

const modules = import.meta.glob(
  [
    '../onabet-public/**/*.{js,jsx}',
    '!../onabet-public/**/__tests__/**',
    '!../onabet-public/**/*.{test,spec}.{js,jsx}',
    '!../onabet-public/**/__mocks__/**',
  ],
  { eager: true },
);
ReactRailsUJS.useContext(buildContext(modules));
